import { AxiosError, AxiosResponse } from "axios";
import { showToast } from "vant";

export const COMMON_ERROR = "网络异常，请稍后重试";

/**
 * Common 通用
 * System 系统异常
 * Network 网络异常
 * Timeout 网络超时
 * Business 业务异常
 */
export type ErrorType = "System" | "Business" | "Timeout" | "Common" | "Network";
export type BusinessDataType = { code: number; msg: string; requestId: string; data: object };
export type ErrorNetInfoDataType = BusinessDataType | AxiosError | AxiosResponse | { msg?: string };
export type ErrorHandleType = string | ((_: unknown) => void) | undefined | boolean;
export type ErrorNetInfo<T = ErrorHandleType> = {
    type: ErrorType;
    data: ErrorNetInfoDataType;
    handle: T;
};

export default class Error {
    static handleNet(info: ErrorNetInfo) {
        const { handle } = info;
        const handleType = getVariantType(handle);
        this.handleNetMap[handleType].call(this, info);
    }
    static handleNetString(info: ErrorNetInfo) {
        showToast((info.handle as string) || COMMON_ERROR);
        this.throwError(info);
    }
    static handleNetFunction(info: ErrorNetInfo) {
        (info.handle as (_: unknown) => void)(info.data);
        this.throwError(info);
    }
    static handleNetBoolean(info: ErrorNetInfo) {
        if (!info.handle) this.throwError(info);
    }
    static handleNetDefault(info: ErrorNetInfo) {
        const data = info.data as BusinessDataType;
        if (!(data && data.code && failCallbackMap[data.code])) {
            showToast(data.msg || COMMON_ERROR);
            this.throwError(info);
        }
        failCallbackMap[data.code](data.msg);
        this.throwError(info);
    }
    static throwError(info: ErrorNetInfo) {
        throw info;
    }
    static handleNetMap: Record<string, (info: ErrorNetInfo) => void> = {
        string: this.handleNetString,
        boolean: this.handleNetBoolean,
        function: this.handleNetFunction,
        undefined: this.handleNetDefault
    };
}

const failCallbackMap: { [_: number]: (msg: string) => void } = {
    50104: errorShowToast(),
    50601: errorShowToast(),
    50602: errorShowToast(),
    80105: errorShowToast("关卡尚未解锁")
};

function errorShowToast(content?: string) {
    return function (msg: string) {
        showToast(content || msg);
    };
}

/**
 * 获取变量的类型
 */
function getVariantType(variant: unknown): string {
    return Object.prototype.toString.call(variant).slice(8, -1).toLowerCase();
}
